import { useMemo } from "react";
import { NEW_CONTRACT_TYPES } from "web_myplann/Goals/constants";
import { getPortfolioDomainItemLabel } from "web_myplann/Goals/Helpers/getPortfolioDomainItemLabel";
import type { NewContractType } from "web_myplann/Goals/Types/NewContractType";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

export const useNewContractTypeOptions =
	(): FlatRowSelectOption<NewContractType>[] => {
		const { t } = useResource();

		return useMemo(
			() =>
				NEW_CONTRACT_TYPES.map((value) => ({
					value,
					label: t(getPortfolioDomainItemLabel(value)),
				})),
			[t],
		);
	};
